/**
 * @generated SignedSource<<9a9ee18d4b808d9023cab55c0ca7a0f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type stripeConnectorPage_DrillQuery$variables = {
  month: string;
  objectType: string;
};
export type stripeConnectorPage_DrillQuery$data = {
  readonly stripeRawObjects: ReadonlyArray<{
    readonly amount: number | null | undefined;
    readonly created: string | null | undefined;
    readonly label: string | null | undefined;
    readonly status: string | null | undefined;
    readonly stripeId: string;
  }>;
};
export type stripeConnectorPage_DrillQuery = {
  response: stripeConnectorPage_DrillQuery$data;
  variables: stripeConnectorPage_DrillQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectType"
},
v2 = [
  {
    "kind": "Variable",
    "name": "month",
    "variableName": "month"
  },
  {
    "kind": "Variable",
    "name": "objectType",
    "variableName": "objectType"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stripeId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "stripeConnectorPage_DrillQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StripeRawObject",
        "kind": "LinkedField",
        "name": "stripeRawObjects",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "stripeConnectorPage_DrillQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StripeRawObject",
        "kind": "LinkedField",
        "name": "stripeRawObjects",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "613e466292d9fe6e4b5eac705b403547",
    "id": null,
    "metadata": {},
    "name": "stripeConnectorPage_DrillQuery",
    "operationKind": "query",
    "text": "query stripeConnectorPage_DrillQuery(\n  $objectType: String!\n  $month: String!\n) {\n  stripeRawObjects(objectType: $objectType, month: $month) {\n    stripeId\n    created\n    status\n    amount\n    label\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f22c045f75f6f778cd646a583a033dfc";

export default node;
